import { render } from "./ProjectScreen.vue?vue&type=template&id=86b964ec&scoped=true"
import script from "./ProjectScreen.vue?vue&type=script&lang=js"
export * from "./ProjectScreen.vue?vue&type=script&lang=js"

import "./ProjectScreen.vue?vue&type=style&index=0&id=86b964ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b964ec"]])

export default __exports__